import { API_BASE_URL as BASE } from './apiConfig';
import { createAuthedAxios } from '@/lib/authedAxios';
import type { User } from '@/contexts/AuthContext';

const client = createAuthedAxios({ baseURL: `${BASE}/api/cafe24` });

// B/E 표준 응답({success,message,data})을 언랩 - planApi.ts와 동일 패턴
client.interceptors.response.use((res) => {
  if (res.data && typeof res.data === 'object' && 'success' in res.data && 'data' in res.data) {
    const wrapped = res.data as { success: boolean; message?: string | null; data: unknown };
    res.data = wrapped.data;
  }
  return res;
});

export interface Cafe24MallLinkStatus {
  mallId: string;
  status: 'PENDING_SIGNUP' | 'ACTIVE';
}

export interface Cafe24LaunchAuthData {
  token: string;
  user: User;
  sessionId?: string;
}

export interface Cafe24InstallIntentResult {
  authorizeUrl: string;
}

export async function recordInstallIntent(mallId: string): Promise<Cafe24InstallIntentResult> {
  const res = await client.post<Cafe24InstallIntentResult>('/install-intent', { mallId });
  return res.data;
}

export async function connectComplete(mallId: string): Promise<Cafe24MallLinkStatus> {
  const res = await client.post<Cafe24MallLinkStatus>('/connect-complete', { mallId });
  return res.data;
}

export async function verifyLaunch(queryString: string): Promise<Cafe24LaunchAuthData> {
  const res = await client.post<Cafe24LaunchAuthData>('/launch/verify', { queryString });
  return res.data;
}

export interface Cafe24AppstoreOrder {
  id: number;
  status: 'CREATED' | 'PAID' | 'REFUND_REQUESTED' | 'REFUNDED' | 'EXPIRED';
  orderName: string;
  orderAmount: number;
  currency: string;
  confirmationUrl: string;
}

/** 카페24 앱스토어 결제 주문 생성 - 응답의 confirmationUrl로 브라우저를 이동시키면 카페24 결제창이 뜬다. */
export async function createAppstoreOrder(planId: string): Promise<Cafe24AppstoreOrder> {
  const res = await client.post<Cafe24AppstoreOrder>('/appstore/orders', { planId });
  return res.data;
}

/** return_url 착지 화면용 - 특정 order id 없이 가장 최근 생성된 주문을 조회한다. */
export async function getLatestAppstoreOrder(): Promise<Cafe24AppstoreOrder> {
  const res = await client.get<Cafe24AppstoreOrder>('/appstore/orders/latest');
  return res.data;
}
